import React from "react";
import PropTypes from "prop-types";
import { DATA_TYPES } from "../../constants";
import DataListItem from "../DataListItem";
import "./styles.scss";

const DataList = ({
  data,
  onCommodityCodeClick,
  onSubmit,
  dataType
}) => {
  if (dataType === DATA_TYPES.COMMODITY_BY_CODE) {
    return data.map(item => /*#__PURE__*/React.createElement(DataListItem, {
      key: item.code,
      description: item.description,
      code: item.code,
      codeLength: 8,
      applyCode: item.applyCode,
      onCommodityCodeClick: onCommodityCodeClick,
      onSubmit: onSubmit
    }));
  }

  return data?.levels?.map(level => level.split(".").map((itemCode, index) => {
    if (itemCode) {
      const item = data.commodities[itemCode];
      return /*#__PURE__*/React.createElement("div", {
        className: `mydpd-commodity-item-padding-left-${index}`
      }, /*#__PURE__*/React.createElement(DataListItem, {
        description: item.description,
        code: item.code,
        codeLength: (index + 1) * 2,
        applyCode: item.applyCode,
        onCommodityCodeClick: onCommodityCodeClick,
        onSubmit: onSubmit
      }));
    } else {
      return null;
    }
  }));
};

DataList.propTypes = {
  data: PropTypes.object,
  onCommodityCodeClick: PropTypes.func,
  onSubmit: PropTypes.func,
  dataType: PropTypes.string
};
export default DataList;